import React from 'react';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import ImageView from 'lib/images/image-view';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import { Site } from 'four-nets/site';
import livingLogoSvg from 'four-nets/icons/svg/modra-strecha-favicon-v2.svg';

import gardenLogo from './garden_logo.png';
import weddingLogo from './wedding_logo.png';
import CollectionNode from '../collections/collection-node/collection-node';
import { RecentCollectionsQuery } from './collection-post.graphql';
import defaultStyles from './collection-post.scss';


export interface Props {
    styles: typeof defaultStyles;
    data?: RecentCollectionsQuery;
    loading: boolean;
}

class CollectionFeed extends React.PureComponent<Props> {
    static contextTypes = {
        site: PropTypes.instanceOf(Site),
    };

    render() {
        const { styles, data, loading } = this.props;
        const { site } = this.context;

        const edges =
            data && data.collections && data.collections.edges && data.collections.edges.length > 0
                ? data.collections.edges
                : undefined;

        return edges || loading ? (
            <div className={styles.container}>
                <div className={styles.collectionHeader}>
                    <div className={styles.info}>
                        <div className={styles.logo}>
                            {site.isGarden ? (
                                <ImageView src={gardenLogo as any} sizes={{ xs: 100 }} aspectFill={true} />
                            ) : site.isLiving ? (
                                <SVGIcon style={{image: styles.icon}} src={livingLogoSvg} />
                            ) : (
                                <ImageView src={weddingLogo as any} sizes={{ xs: 100 }} aspectFill={true} />
                            )}
                        </div>
                        <span className={styles.postTitle}>
                            <FormattedMessage id='NEWEST_COLLECTIONS' />
                        </span>
                    </div>
                    <Link className={styles.allCollections} to='/blogs/collections'>
                        <FormattedMessage id='SHOW_ALL_COLLECTIONS' />
                    </Link>
                </div>
                <ul className={styles.collections}>
                    {edges
                        ? edges.map((edge, index) =>
                              edge && edge.node ? (
                                  <li key={index} className={styles.collectionItem}>
                                      <CollectionNode
                                          style={{
                                              header: styles.header,
                                              headerInfo: styles.headerInfo,
                                              username: styles.username,
                                              timeText: styles.timeText,
                                              iconActivity: styles.iconActivity,
                                              images: styles.images,
                                              footer: styles.footer,
                                              title: styles.title,
                                              iconCamera: styles.iconCamera,
                                              iconHeart: styles.iconHeart,
                                              stats: styles.stats,
                                              new: styles.new,
                                          }}
                                          {...edge.node}
                                      />
                                  </li>
                              ) : null
                          )
                        : [null, null, null].map((_, index) => (
                              <li key={index} className={styles.placeholderCollectionItem}>
                                  <div className={styles.placeholder}>
                                      <div className={styles.box1} />
                                      <div className={styles.box2} />
                                  </div>
                              </li>
                          ))}
                </ul>
            </div>
        ) : null;
    }
}

export default Styled(defaultStyles)(CollectionFeed);
